import gql from 'graphql-tag';

export const CREATE_OR_UPDATE_LIVING_WILL_MUTATION = gql`
  mutation createOrUpdateLivingWill($livingWillInputDetails: LivingWillInput!) {
    createOrUpdateLivingWill(livingWillInput: $livingWillInputDetails) {
      id
      testatorId
      keptAliveByArtificialMeans
      keptAliveTimePeriod
      keptAliveTimeAmount
      resuscitate
      comfortCare
      decisionMakerNotify
      includeBurialWishes
    }
  }
`;
